"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCUHealth = exports.SCULogLevel = exports.SCULogItem = exports.SCUModuleFault = exports.SCUModule = exports.SCUModuleStatus = void 0;
var cerealParse_1 = require("../cerealParse");
var SCUModuleStatus;
(function (SCUModuleStatus) {
    SCUModuleStatus[SCUModuleStatus["ok"] = 0] = "ok";
    SCUModuleStatus[SCUModuleStatus["warning"] = 1] = "warning";
    SCUModuleStatus[SCUModuleStatus["error"] = 2] = "error";
})(SCUModuleStatus = exports.SCUModuleStatus || (exports.SCUModuleStatus = {}));
var SCUModule = /** @class */ (function () {
    function SCUModule(id, name, faults) {
        this.id = id;
        this.name = name;
        this.faults = faults;
    }
    Object.defineProperty(SCUModule.prototype, "faultStatus", {
        get: function () {
            return this.faults.reduce(function (acc, c) { return c.level > acc ? c.level : acc; }, SCUModuleStatus.ok);
        },
        enumerable: false,
        configurable: true
    });
    SCUModule.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUModule(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'faults', SCUModuleFault.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUModule Model: " + e.message);
        }
    };
    return SCUModule;
}());
exports.SCUModule = SCUModule;
var SCUModuleFault = /** @class */ (function () {
    function SCUModuleFault(startTs, code, level, message) {
        this.startTs = startTs;
        this.code = code;
        this.level = level;
        this.message = message;
    }
    SCUModuleFault.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUModuleFault(cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'startTs'), cerealParse_1.ParseUtils.getString(o, 'code'), cerealParse_1.ParseUtils.getEnum(o, 'level', SCUModuleStatus), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUModuleFault Model: " + e.message);
        }
    };
    return SCUModuleFault;
}());
exports.SCUModuleFault = SCUModuleFault;
var SCULogItem = /** @class */ (function () {
    function SCULogItem(id, ts, code, level, message) {
        this.id = id;
        this.ts = ts;
        this.code = code;
        this.level = level;
        this.message = message;
    }
    SCULogItem.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCULogItem(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getISODate(o, 'ts'), cerealParse_1.ParseUtils.getStringOrNull(o, 'code'), cerealParse_1.ParseUtils.getEnum(o, 'level', SCULogLevel), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCULogItem Model: " + e.message);
        }
    };
    SCULogItem.compare = function (l1, l2) {
        return l2.ts.getTime() - l1.ts.getTime() || l2.message.localeCompare(l1.message);
    };
    return SCULogItem;
}());
exports.SCULogItem = SCULogItem;
var SCULogLevel;
(function (SCULogLevel) {
    SCULogLevel[SCULogLevel["info"] = 0] = "info";
    SCULogLevel[SCULogLevel["priority"] = 1] = "priority";
    SCULogLevel[SCULogLevel["warning"] = 2] = "warning";
    SCULogLevel[SCULogLevel["error"] = 3] = "error";
})(SCULogLevel = exports.SCULogLevel || (exports.SCULogLevel = {}));
var SCUHealth = /** @class */ (function () {
    function SCUHealth(logs, modules) {
        this.logs = logs;
        this.modules = modules;
    }
    SCUHealth.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUHealth(cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'logs', SCULogItem.parse, 'warn'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'modules', SCUModule.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUHealth Model: " + e.message);
        }
    };
    return SCUHealth;
}());
exports.SCUHealth = SCUHealth;
//# sourceMappingURL=scuHealth.js.map